import { useMemo } from 'react'

import { useSessionCart } from '../context/cart'
import { useClinician } from '../data/use-clinician'
import { useProducts } from '../data/use-products'

export function useCartProduct() {
  const { products, isLoading } = useProducts()
  const cart = useSessionCart()

  const { productId, patientId, symptoms, summary, schedule, clinicianId, createdAt, lockedAt } = cart.product || {}
  const { clinician } = useClinician(clinicianId)

  const product = useMemo(() => {
    return products?.find(p => p.id === productId) ?? null
  }, [productId, products])

  return {
    product,
    clinician,
    patientId,
    createdAt,
    lockedAt,
    schedule: schedule ?? undefined,
    symptoms: symptoms ?? [],
    summary: summary,
    isLoading,
  }
}
